import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Currency from '../Currency';

import styles from './AutomaticRecurringPaymentSchedule.module.scss';

const AutomaticRecurringPaymentScheduleTable = ({ paymentSchedule }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>#</th>
            <th>{t('paymentScheduleTable.paymentDate')}</th>
            <th>{t('paymentScheduleTable.paymentAmount')}</th>
          </tr>
        </thead>
        <tbody>
          {paymentSchedule.map((item, index) => (
            <tr key={`${item.beforeDate}`}>
              <td>{index + 1}</td>
              <td>{item.beforeDate}</td>
              <td>
                <Currency value={item.amount} withCurrencyLabel />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

AutomaticRecurringPaymentScheduleTable.propTypes = {
  paymentSchedule: PropTypes.arrayOf(PropTypes.shape({
    beforeDate: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  })),
};

AutomaticRecurringPaymentScheduleTable.defaultProps = {
  paymentSchedule: [],
};

export default AutomaticRecurringPaymentScheduleTable;
